import { JobRequestInspectionStatus } from '~/gql/graphql'

export const JOB_REQUEST_LIST_PAGINATION_LIMIT = 40

export const PRIORITY_DISPLAY_VALUES = Object.freeze({
    very_urgent: 'Very urgent',
    urgent: 'Urgent',
    normal: 'Normal',
    not_urgent: 'Not urgent',
})

export const JobRequestSortMapping: { [key: string]: string } = {
    vendorDueDate_ascend: 'VENDOR_DUE_DATE_ASC',
    vendorDueDate_descend: 'VENDOR_DUE_DATE_DESC',
}

export const DEFAULT_SEARCH_TYPE = 'jobRequest'
export const DATE_FORMAT = 'YYYY/MM/DD'
export const JobRequestListPagePlacement = 'JobRequestListPage'

export const INSPECTION_STATUS_FILTER = [
    {
        label: 'Completed',
        value: JobRequestInspectionStatus.completed,
    },
    { label: 'In progress', value: JobRequestInspectionStatus.in_progress },
    { label: 'Not started', value: JobRequestInspectionStatus.pending },
]
